import { Component, type ErrorInfo, type ReactNode } from 'react';
import { BrandMark, Button } from '@/components/ui';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled UI error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="grid min-h-dvh place-items-center bg-canvas px-6 text-center">
        <div className="max-w-md">
          <BrandMark className="mx-auto size-20" />
          <h1 className="mt-6 font-heading text-2xl font-semibold text-ink">Something went wrong</h1>
          <p className="mt-2 text-ink-muted">An unexpected error stopped this page. Reloading usually fixes it.</p>
          <div className="mt-6 flex justify-center gap-2">
            <Button size="lg" onClick={() => window.location.reload()}>
              Reload
            </Button>
            <Button size="lg" variant="outline" onClick={() => (window.location.href = '/')}>
              Go home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
